import { reactive } from 'vue'

interface FeatureFlag {
  [key: string]: boolean
}

const state = reactive<{
  version: string
  rollbarEnabled: boolean
  rollbarApiKey: string
  appEnvironment: string
  featureFlags: FeatureFlag
}>({
  version: '',
  rollbarEnabled: false,
  rollbarApiKey: '',
  appEnvironment: '',
  featureFlags: {},
})

const store = {
  get config() {
    return state
  },
  setConfig(config: any) {
    state.version = config.version
    state.rollbarEnabled = config.rollbarEnabled
    state.rollbarApiKey = config.rollbarApiKey
    state.appEnvironment = config.appEnvironment
    state.featureFlags = config.featureFlags
  },
}

export default store
